import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'react-final-form';

import validators from 'forms/validators';
import { RenderField, normalizers } from 'forms';
import SprayOperatorsDropdown from 'components/SprayOperatorsDropdown';
import ChangeFieldValueBasedOnAnotherFieldValue from 'components/ChangeFieldValueBasedOnAnotherFieldValue';
import FertilizerEventApplicationMethodDropdown from './components/FertilizerEventApplicationMethodDropdown';
import FertilizerEventJustificationDropdown from './components/FertilizerEventJustificationDropdown';

const { toNull } = normalizers;
const { isRequired } = validators;

export default function FertilizerEventApplicationPage(): React.ReactElement {
    return (
        <Grid className="spray-event-modal-step">
            <ChangeFieldValueBasedOnAnotherFieldValue
                fieldToBeListened="fertilizerJustificationOption"
                fieldToBeChanged="justification"
            />
            <Grid.Row>
                <Grid.Column width="8">
                    <h4>Application details</h4>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <SprayOperatorsDropdown
                        label="Applicator"
                        name="operatorPersonId"
                        validate={isRequired}
                        placeholder="Add an applicator"
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="16">
                    <Field
                        component={RenderField as any}
                        name="technicalPersonName"
                        label="Technically responsible person"
                        nullOnUnmount={false}
                        parse={toNull}
                        validate={isRequired}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="8">
                    <Field
                        component={RenderField as any}
                        name="supplier"
                        label="Contractor"
                        nullOnUnmount={false}
                        parse={toNull}
                    />
                </Grid.Column>
                <Grid.Column width="8">
                    <FertilizerEventApplicationMethodDropdown
                        name="applicationMethod"
                        nullOnUnmount={false}
                        validate={isRequired}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="8">
                    <FertilizerEventJustificationDropdown
                        name="fertilizerJustificationOption"
                        placeholder="Add a default justification"
                    />
                </Grid.Column>
                <Grid.Column width="8">
                    <Field
                        component={RenderField as any}
                        name="justification"
                        label="Justification"
                        nullOnUnmount={false}
                        parse={toNull}
                        validate={isRequired}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="16">
                    <Field
                        component={RenderField as any}
                        name="comment"
                        label="Additional comments"
                        nullOnUnmount={false}
                        parse={toNull}
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
